module.exports = __webpack_public_path__ + "static/media/term.89e47ddd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/term.svg
// module id = 537
// module chunks = 0